import { IServiceSuccess } from 'core/model/interfaces/service.interface';
import { https } from 'core/services/https';
import type { IAddressDTO, IGetCreditLimitsDTO, IGetUserProfileResponseV2 } from './customers.dto';

export const baseUrl = (version = 'v1') => `/${version}/users`;
export const customersData = {
  getProfileUser: async (customerId: number): Promise<IGetUserProfileResponseV2> =>
    https.get<IGetUserProfileResponseV2>(`${baseUrl()}/profile`, {
      headers: { 'Gtm-Customer-Id': customerId },
    }),
  getAddresses: async (): Promise<Array<IAddressDTO>> => https.get<Array<IAddressDTO>>(`${baseUrl()}/addresses`),

  getCreditLimits: async (customerId: number): Promise<IGetCreditLimitsDTO> => {
    const { data } = await https.get<IServiceSuccess<IGetCreditLimitsDTO>>(`${baseUrl()}/credit-limits`, {
      headers: { 'customer-id': customerId },
    });
    return data;
  },
};
